import { Model2 } from "../models/Model2";
import { baseUrl, headers } from "./config";
import { fetchAndParse } from "./utils";
export function getStatusDeviceid(deviceID: string): Promise<Model2> {
    const url = new URL(`/status/${deviceID}`, baseUrl);
    return fetchAndParse<Model2>(url.toString(), { method: "GET", headers });
}

